export default "__VITE_ASSET__CLdPCY4v__"